define( function () {
  return window.pageContextJavascript;
} );
